import { initalAppConfig } from "../../system/initial/appConfig";
import {SystemInterface} from "./interface";
import {SYSTEM_ACTIONS, SystemState} from "./types";

const initialState: SystemState = {
    themeDark: true,
    languages: [],
    appConfig: initalAppConfig
};

const systemReducer = (
    state: SystemState | undefined,
    action: SystemInterface
):SystemState  => {
    if (typeof state === 'undefined') {
        state = initialState;
    }

    switch (action.type) {
        case SYSTEM_ACTIONS.systemToggleDarkTheme:
            const themeStatus = state.themeDark;
            return {
                ...state,
                themeDark: !themeStatus
            };
        case SYSTEM_ACTIONS.systemSetLanguages:
            return {
                ...state,
                languages: action.payload,
            }
        case SYSTEM_ACTIONS.systemSetAppConfig:
            return {
                ...state,
                appConfig: action.payload,
            }; 
        default:
            return state;
    }
}

export { systemReducer };
